"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDemoAuth = exports.DemoAuthProvider = void 0;
var react_1 = __importDefault(require("react"));
var ai_hub_rbac_api_service_1 = require("../services/ai-hub-rbac-api.service");
var DEMO_AUTH_STORAGE_KEY = 'ws-ai-hub-demo-auth-user-id';
var FALLBACK_USER = {
    id: 'unknown-user',
    displayName: 'Unknown User',
    role: 'regular-user',
    permissions: [],
};
var isSystemRoleName = function (roleName) {
    return roleName === 'admin' ||
        roleName === 'owner' ||
        roleName === 'group-owner' ||
        roleName === 'reviewer' ||
        roleName === 'regular-user';
};
var getRoleName = function (user) {
    var _a, _b;
    var roleName = (_b = (_a = user.role) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
    if (!roleName || !isSystemRoleName(roleName)) {
        return 'regular-user';
    }
    return roleName;
};
var getUserPermissions = function (user) {
    if (Array.isArray(user.scopeGrants)) {
        return user.scopeGrants.filter(function (scopeGrant) { return typeof scopeGrant === 'string'; });
    }
    if (Array.isArray(user.permissions)) {
        return user.permissions.filter(function (permission) { return typeof permission === 'string'; });
    }
    return [];
};
var mapApiUserToDemoUser = function (user) {
    var id = typeof user.objectId === 'string' ? user.objectId.trim() : '';
    if (!id) {
        return null;
    }
    var displayName = (typeof user.displayName === 'string' && user.displayName.trim().length > 0
        ? user.displayName.trim()
        : undefined) ||
        (typeof user.email === 'string' && user.email.trim().length > 0
            ? user.email.trim()
            : undefined) ||
        id;
    return {
        id: id,
        displayName: displayName,
        role: getRoleName(user),
        permissions: getUserPermissions(user),
    };
};
var findUserById = function (users, id) {
    if (!id) {
        return null;
    }
    return users.find(function (user) { return user.id === id; }) || null;
};
var noop = function () { return undefined; };
var DemoAuthContext = react_1.default.createContext({
    activeUser: FALLBACK_USER,
    availableUsers: [FALLBACK_USER],
    setActiveUserId: noop,
    resetActiveUser: noop,
});
exports.DemoAuthProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.default.useState([
        FALLBACK_USER,
    ]), availableUsers = _b[0], setAvailableUsers = _b[1];
    var _c = react_1.default.useState(FALLBACK_USER), fallbackActiveUser = _c[0], setFallbackActiveUser = _c[1];
    var _d = react_1.default.useState(function () {
        if (typeof window === 'undefined') {
            return null;
        }
        return window.localStorage.getItem(DEMO_AUTH_STORAGE_KEY);
    }), activeUserId = _d[0], setActiveUserIdState = _d[1];
    react_1.default.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, currentUserResult, usersResult, mappedCurrentUser, mappedUsers, usersById, nextAvailableUsers, nextFallbackUser, storedId, initialActiveUser;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            ai_hub_rbac_api_service_1.fetchCurrentUser(),
                            ai_hub_rbac_api_service_1.fetchUsers(),
                        ])];
                    case 1:
                        _a = _b.sent(), currentUserResult = _a[0], usersResult = _a[1];
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        mappedCurrentUser = currentUserResult ? mapApiUserToDemoUser(currentUserResult) : null;
                        mappedUsers = usersResult
                            .map(function (user) { return mapApiUserToDemoUser(user); })
                            .filter(function (user) { return user !== null; });
                        usersById = new Map();
                        mappedUsers.forEach(function (user) {
                            usersById.set(user.id, user);
                        });
                        if (mappedCurrentUser) {
                            usersById.set(mappedCurrentUser.id, mappedCurrentUser);
                        }
                        nextAvailableUsers = Array.from(usersById.values());
                        if (nextAvailableUsers.length > 0) {
                            setAvailableUsers(nextAvailableUsers);
                        }
                        nextFallbackUser = mappedCurrentUser || nextAvailableUsers[0] || FALLBACK_USER;
                        setFallbackActiveUser(nextFallbackUser);
                        storedId = typeof window !== 'undefined' ? window.localStorage.getItem(DEMO_AUTH_STORAGE_KEY) : null;
                        initialActiveUser = findUserById(nextAvailableUsers, activeUserId) ||
                            findUserById(nextAvailableUsers, storedId) ||
                            nextFallbackUser;
                        setActiveUserIdState(initialActiveUser.id);
                        if (typeof window !== 'undefined') {
                            window.localStorage.setItem(DEMO_AUTH_STORAGE_KEY, initialActiveUser.id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, []);
    var activeUser = react_1.default.useMemo(function () { return findUserById(availableUsers, activeUserId) || fallbackActiveUser; }, [activeUserId, availableUsers, fallbackActiveUser]);
    var setActiveUserId = react_1.default.useCallback(function (userId) {
        var nextUser = findUserById(availableUsers, userId) || fallbackActiveUser;
        setActiveUserIdState(nextUser.id);
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(DEMO_AUTH_STORAGE_KEY, nextUser.id);
        }
    }, [availableUsers, fallbackActiveUser]);
    var resetActiveUser = react_1.default.useCallback(function () {
        setActiveUserIdState(fallbackActiveUser.id);
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem(DEMO_AUTH_STORAGE_KEY);
        }
    }, [fallbackActiveUser.id]);
    var value = react_1.default.useMemo(function () { return ({
        activeUser: activeUser,
        availableUsers: availableUsers,
        setActiveUserId: setActiveUserId,
        resetActiveUser: resetActiveUser,
    }); }, [activeUser, availableUsers, resetActiveUser, setActiveUserId]);
    return react_1.default.createElement(DemoAuthContext.Provider, { value: value }, children);
};
exports.useDemoAuth = function () { return react_1.default.useContext(DemoAuthContext); };
